module.exports = __webpack_public_path__ + "static/media/text-bd.50ebc816.svg";


//////////////////
// WEBPACK FOOTER
// ./src/playground/components/face/img/faces/ym/text-bd.svg
// module id = 399
// module chunks = 0